module.exports = __webpack_public_path__ + "img/20200514_140611.69cc5ac2.jpg";